const $inject = [];

const lbPasswordStrength = function () {
  return {
    restrict: 'A',
    require: ['ngModel'],
    compile: function () {
      return function ($scope, $element, $attributes, controllers) {
        const ngModel = controllers[0];
        const MIN_LENGTH = 8;

        ngModel.$validators.number = function (value) {
          if(typeof value === 'undefined') {
            return false;
          }

          return /[0-9]+/.test(value);
        };

        ngModel.$validators.lower = function (value) {
          if(typeof value === 'undefined') {
            return false;
          }

          return /[a-z]+/.test(value);
        };

        ngModel.$validators.upper = function (value) {
          if(typeof value === 'undefined') {
            return false;
          }

          return /[A-Z]+/.test(value);
        };

        ngModel.$validators.limit = function (value) {
          if(typeof value === 'undefined') {
            return false;
          }

          return value.length >= MIN_LENGTH;
        };

        ngModel.$validate();
      }
    }
  }
};

lbPasswordStrength.$inject = $inject;

export default lbPasswordStrength;


// WEBPACK FOOTER //
// ./src/directives/lbPasswordStrength.js